import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import Tooltip from 'components/common/Tooltip';
import MoreInfo from 'components/icons/MoreInfo';
import css from 'styles/components/productdetail/sizingRecommendationTooltip.scss';

export class SizingRecommendationTooltip extends Component {

  state = {
    isModalOpen: false
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  render () {
    const { isModalOpen } = this.state;
    const { dimensionName, selectedVal, sizingPredictionId, sizingPredictionVal } = this.props;
    const content =
      <span className={css.recommendedSizingTooltipContent}>
        Recommended sizing is based on your past purchases and the purchases of similar customers. We blend it all together to get you the perfect fit! Hooray!
      </span>;

    if (!sizingPredictionVal) {
      return null;
    }

    return (
      <div className={css.recommendedSizeTooltipWrap}>
        <Tooltip
          tooltipId="sizeReccommendation"
          direction="left"
          content={content}>
          <MoreInfo className={css.recommendedSizeHoverIcon} />
          {(dimensionName === 'size' && selectedVal === sizingPredictionId) ? (
            <span className={css.recommendedSizeText}>
              Your recommended size has been selected.
            </span>
          ) : (
            <span className={css.recommendedSizeText}>
              Your recommended size is <strong>{sizingPredictionVal}</strong>.
            </span>
          )}
        </Tooltip>
        <div className={css.mobileTextIconWrap}>
          <MoreInfo className={css.mobileRecommendedSizeHoverIcon} onClick={this.openModal} />
          {(dimensionName === 'size' && selectedVal === sizingPredictionId) ? (
            <span className={css.mobileRecommendedSizeText}>
              Your recommended size has been selected!
            </span>
          ) : (
            <span className={css.mobileRecommendedSizeText}>
              Your recommended size is <strong>{sizingPredictionVal}</strong>
            </span>
          )}
          <Modal
            isOpen={isModalOpen}
            onRequestClose={this.closeModal}
            portalClassName={css.modalPortal}
            overlayClassName={css.modalOverlay}
            className={css.modalContent}
            contentLabel="SizingModal">
            <div className={css.modalText}>
              Recommended sizing is based on your past purchases and the purchases of similar customers. We blend it all together to get you the perfect fit! Hooray!
            </div>
            <button type="button" onClick={this.closeModal} className={css.gotItButton}>got it!</button>
          </Modal>
        </div>
      </div>
    );
  }
}

SizingRecommendationTooltip.propTypes = {
  selectedVal: PropTypes.string,
  dimensionName: PropTypes.string,
  sizingPredictionVal: PropTypes.string,
  sizingPredictionId: PropTypes.string
};

export default SizingRecommendationTooltip;
